import { AbwesenheitenAccordion } from '@/domain/mitarbeiter/features/guttagekonto/components/AbwesenheitenAccordion';
import { AbwesenheitenTable } from '@/domain/mitarbeiter/features/guttagekonto/components/AbwesenheitenTable';
import { Heading } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenWrapper() {
  const { t } = useTranslation();
  return (
    <>
      <Heading size="md">
        {t('domain.mitarbeiter.guttagekonto.abwesenheiten')}
      </Heading>
      <div className="hidden md:block">
        <AbwesenheitenTable />
      </div>
      <div className="block md:hidden">
        <AbwesenheitenAccordion />
      </div>
    </>
  );
}
